import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Card from 'components/Card';

function CellAdherence(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { adherence } = props;
  const isAttended = adherence.atendida === 'S';
  const statusColor = isAttended ? '#00bc97' : '#f44336';

  function viewInterestedDrivers(load_id) {
    if (!load_id) return;

    dispatch({
      type: 'VIEW_DRIVERS',
      title: 'Motoristas Interessados',
      currentLoadId: load_id,
      url: `/relatorios/aderencia-motoristas/${load_id}`,
    });

    navigate(`/relatorios/aderencia-motoristas/${load_id}`);
  }

  const topSectionMinHeight = { xs: 'auto', md: 58 };

  return (
    <Card
      style={{ marginBottom: '20px' }}
      bordered={1}
      borderhexcolor={statusColor}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 4,
          flexWrap: { xs: 'wrap', md: 'nowrap' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 3, md: 6 },
            flex: 1,
            minWidth: 0,
            flexWrap: { xs: 'wrap', md: 'nowrap' },
          }}
        >
          <Box sx={{ minWidth: { md: 150 } }}>
            <Box sx={{ minHeight: topSectionMinHeight }}>
              <Typography variant="caption" component="p" gutterBottom>
                CARGA
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong style={{ color: statusColor }}>{adherence.id}</strong>
              </Typography>
            </Box>

            <Box mt={1.25}>
              <Typography variant="caption" component="p" gutterBottom>
                ORIGEM
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong>
                  {adherence.origin_city && adherence.origin_city.toUpperCase()} -{' '}
                  {adherence.origin_province && adherence.origin_province.toUpperCase()}
                </strong>
              </Typography>
            </Box>
          </Box>

          <Box sx={{ minWidth: { md: 150 } }}>
            <Box sx={{ minHeight: topSectionMinHeight }}>
              <Typography variant="caption" component="p" gutterBottom>
                EMPRESA
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong>{adherence.company_name}</strong>
              </Typography>
            </Box>

            <Box mt={1.25}>
              <Typography variant="caption" component="p" gutterBottom>
                DESTINO
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong>
                  {adherence.destination_city && adherence.destination_city.toUpperCase()} -{' '}
                  {adherence.destination_province && adherence.destination_province.toUpperCase()}
                </strong>
              </Typography>
            </Box>
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box sx={{ minHeight: topSectionMinHeight }}>
              <Typography variant="caption" component="p" gutterBottom>
                CLIENTE
              </Typography>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ wordBreak: 'break-word' }}
              >
                <strong>
                  {adherence.client_social_name} - {adherence.client_cgccpf}
                </strong>
              </Typography>
            </Box>

            <Box
              mt={1.25}
              sx={{
                display: 'flex',
                gap: 4,
              }}
            >
              <Box>
                <Typography variant="caption" component="p" gutterBottom>
                  VISUALIZAÇÕES
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <strong>{adherence.qtdVisualizations}</strong>
                </Typography>
              </Box>

              <Box>
                <Typography variant="caption" component="p" gutterBottom>
                  INTERESSES
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <strong>{adherence.qtdInterested}</strong>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            minWidth: { xs: '100%', md: 210 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'flex-end' },
            gap: 2,
          }}
        >
          <Box sx={{ minHeight: topSectionMinHeight }}>
            <Typography
              variant="body2"
              gutterBottom
              sx={{ color: statusColor, textAlign: { xs: 'left', md: 'right' } }}
            >
              <strong>{isAttended ? 'Carga Atendida' : 'Carga não Atendida'}</strong>
            </Typography>
          </Box>

          <Link
            href=""
            style={{
              fontWeight: 'bold',
              textTransform: 'uppercase',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
            onClick={() => viewInterestedDrivers(adherence.id)}
          >
            Ver motoristas <i className="fas fa-chevron-right" />
          </Link>
        </Box>
      </Box>
    </Card>
  );
}

export default CellAdherence;
